const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export default API_URL;
